import styled from 'styled-components';

export const StyledAction = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  grid-gap: 10px;
  text-align: initial;
  @media (max-width: 1200px) {
    flex-direction: column;
    align-items: initial;
    text-align: center;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  h1 {
    margin-bottom: 32px;
  }
  form {
    display: flex;
    flex-direction: column;
    width: 100%;
    .MuiFormControl-root {
      width: 360px;
      margin-bottom: 10px;
      svg {
        width: 0.7em;
      }

      @media (max-width: 380px) {
        width: 250px;
      }
    }
  }
`;

export const ContainerForBanner = styled(Container)`
  align-items: initial;
  @media (max-width: 1200px) {
    text-align: center;
  }
`;
